angular.module("vgresiduos").controller("OrganizationUnitResidueEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `unidade/residuo/${$stateParams.residueCode}`);
		};
	}
]);
